export default __webpack_public_path__ + "static/media/wedding.88f287bf.jpg";